// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__P00E-","errors":"Errors_errors__25sMM"};